import Input from "./Input";

// eslint-disable-next-line @typescript-eslint/naming-convention
const Select =
  // `Input` and `Select` are not fully compatible (they have different
  // `parts`), but the custom styles currently are identical so we can just have
  // `Select` inherit all the customizations from `Input` for now. This may
  // not always be the case...
  Input;

export default Select;
